import { useEffect, useState } from 'react';
import { BASE_URL } from '../constants/urls';
import axios from 'axios';
import { AUTH_CHANGED_EVENT } from '../utils/dataLayer';

const useUserData = () => {
    const [user, setUser] = useState({});
    const [loadingUser, setLoading] = useState(true);
    const [errorUser, setError] = useState(null);
    // Incrementa a cada login/atualização de perfil para buscar o usuário de novo
    const [refreshKey, setRefreshKey] = useState(0);

    const token = localStorage.getItem("token");

    useEffect(() => {
        const handleAuthChanged = () => setRefreshKey((key) => key + 1);
        window.addEventListener(AUTH_CHANGED_EVENT, handleAuthChanged);
        return () => window.removeEventListener(AUTH_CHANGED_EVENT, handleAuthChanged);
    }, []);

    useEffect(() => {

        if (!token) {
        setError("Token não Encontrado");
        setLoading(false);
        return;
        }

        const fetchUserData = async () => {
        try {
            setLoading(true);
            const res = await axios.get(`${BASE_URL}/pbw-meucupom-users`, {
            params: { token },
            headers: { Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}` }
            });
            setUser(res.data);
            setError(null);
        } catch (err) {
            const msg = err?.response?.data?.message || err.message || 'Erro desconhecido';
            setError(msg);
        } finally {
            setLoading(false);
        }
        };

        fetchUserData();
    }, [token, refreshKey]);

    return { user, loadingUser, errorUser };
};

export default useUserData;
